import { z } from 'zod';

/**
 * The public shape of a user — returned to clients, logged, anything that
 * isn't the store itself. Never carries a password or password hash.
 */
export const User = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string(),
  createdAt: z.string(),
});
export type User = z.infer<typeof User>;

export const RegisterInput = z.object({
  email: z.string().email(),
  password: z.string().min(8, 'Password must be at least 8 characters'),
  name: z.string().min(1, 'Name is required'),
});
export type RegisterInput = z.infer<typeof RegisterInput>;

export const LoginInput = z.object({
  email: z.string().email(),
  password: z.string().min(1, 'Password is required'),
});
export type LoginInput = z.infer<typeof LoginInput>;

/** Body for both `/api/auth/refresh` and `/api/auth/logout` — both act on a
 * single presented refresh token. */
export const RefreshInput = z.object({
  refreshToken: z.string().min(1),
});
export type RefreshInput = z.infer<typeof RefreshInput>;

export const AuthTokens = z.object({
  /** Short-lived, carries only the user id — see `apps/api/src/lib/auth.ts`. */
  accessToken: z.string(),
  /** Opaque; the server holds a hashed copy so it can be revoked. */
  refreshToken: z.string(),
});
export type AuthTokens = z.infer<typeof AuthTokens>;

export const AuthResponse = z.object({
  user: User,
  tokens: AuthTokens,
});
export type AuthResponse = z.infer<typeof AuthResponse>;
